import { Promise } from 'es6-promise';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// BEW
import { Footer as SkypeFooter } from '@skype/bew-components/dist/UHF/Footer';
import { Header as UhfHeader } from '@skype/bew-components/dist/UHF/Header';
import { getStaticHost } from '@skype/bew-helpers/dist/getStaticHost';
import { parseQuery } from '@skype/bew-helpers/dist/parseQuery';
import { stringifyQuery } from '@skype/bew-helpers/dist/stringifyQuery';
import { LocalizationApiProvider, localizer } from '@skype/bew-localization';

// Default styles/resets
import * as classNames from 'classnames/bind';
import * as styles from './styles.css';

const cx = classNames.bind(styles);

interface UhfLoadConf {
    authToken?: string;
    domain?:    string;
}

class Uhf extends React.Component<UhfLoadConf, {}> {

    private content: HTMLDivElement;

    componentDidMount() {
        // Intentionally not using "Array.from" since it requires polyfilling for IE11
        const elems = Array.prototype.slice.call(document.body.children).filter((e: HTMLElement) =>
            e.constructor !== HTMLScriptElement && e.id !== ROOT_CONTAINER
        ).reverse();

        while (elems.length) {
            this.content.appendChild(elems.pop() as Node);
        }

        renderCallback();
    }

    render() {
        return (
            <div className={ cx('reactRoot') }>
                <UhfHeader
                    localizer={ localizer }
                    includeCookieCompliance={ !this.props.authToken }
                    authToken={ this.props.authToken || undefined }
                    domain={ this.props.domain || undefined }
                />

                <div className={ cx('content') } ref={ content => this.content = content as HTMLDivElement } />

                <SkypeFooter
                    footerId = 'SkypeFooter'
                    localizer={ localizer }
                    languageSwitchCallback={ language => {
                        const currentQuery = parseQuery(window.location.search) as any;
                        currentQuery.setlang = language;
                        window.location.href =
                            window.location.origin +
                            window.location.pathname +
                            '?' + stringifyQuery(currentQuery);
                        }
                    }
                />
            </div>
        );
    }
}

const initLocalizer = (language: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        localizer
            .initAsync({ locale: language })
            .loadAsync([
                new LocalizationApiProvider(
                    getStaticHost() + '/static/commerce.web.account-client/translations/components/bew/',
                    '?' + new Date().toISOString().split('T')[0].replace(/-/g, '')
                )
            ])
            .then(resolve)
            .catch(e => reject(e));
    });
};

const ROOT_CONTAINER = 'reactContainer';

let renderCallback: () => void;

interface UhfRenderConfig {
    locale:     string;
    callback:   () => void;
    authToken?: string;
    domain?:    string;
}

export const render = (conf: UhfRenderConfig) => {
    try {
        renderCallback = conf.callback;

        const pageContainer = document.createElement('div');
        pageContainer.id = ROOT_CONTAINER;
        document.body.appendChild(pageContainer);

        initLocalizer(conf.locale)
            .then(() => ReactDOM.render(
                <Uhf authToken={ conf.authToken } domain={ conf.domain } />,
                document.getElementById(ROOT_CONTAINER)
            ))
            .catch(e => {
                console.error(e);
                renderCallback();
            });
    } catch (e) {
        console.error(e);
        renderCallback();
    }
};
